import * as ApiActions from '../../constants/ApiActions';
import * as UseCaseActions from '../../constants/UseCases';

import { autoLogin } from './autoLogin';
import { changeInteractiveRadioMode } from './changeInteractiveRadioMode';
import { closeSearch } from './closeSearch';
import { generateDeepLink } from './generateDeepLink';
import { handlePremiumAccess } from './handlePremiumAccess';
import * as UseCaseHandlers from './handlers';
import { initiatePremiumAccess } from './initiatePremiumAccess';
import { login } from './login';
import { openErrorToast } from './openErrorToast';
import { openSearch } from './openSearch';
import { playResumeSource } from './playResumeSource';
import { playRewardsAd } from './playRewardsAd';
import { closeRewardsCoachmark } from './playRewardsAd/helpers';
import { replayTrack } from './replayTrack';
import { resetPasswordAndReauth } from './resetPasswordAndReauth';
import { scrubTrack } from './scrubTrack';
import { setSourceRepeatMode } from './setSourceRepeatMode';
import { setSourceShuffleMode } from './setSourceShuffleMode';
import { signOut } from './signOut';
import { signUp } from './signUp';
import { skipAd } from './skipAd';
import { skipAudioAd } from './skipAudioAd';
import { skipTrackBack } from './skipTrackBack';
import { skipTrackForward } from './skipTrackForward';
import { startStation } from './startStation';
import { trackFeedback } from './trackFeedback';
import { upgrade } from './upgrade';

export default [
  {
    actionType: UseCaseActions.ActionTypes.LOGIN_LISTENER,
    handler: login,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.AUTO_LOGIN,
    handler: autoLogin,
    concur: 'takeOnce',
  },
  {
    actionType: UseCaseActions.ActionTypes.RESET_PASSWORD_AND_REAUTH,
    handler: resetPasswordAndReauth,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.PAUSE_TRACK,
    handler: UseCaseHandlers.pauseTrack,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.SKIP_TRACK_BACK,
    handler: skipTrackBack,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.SKIP_TRACK_FORWARD,
    handler: skipTrackForward,
    concur: 'takeOnly',
  },
  {
    // This handles audio ad skips when station APS is disabled.
    actionType: UseCaseActions.ActionTypes.SKIP_AUDIO_AD,
    handler: skipAudioAd,
    concur: 'takeOnly',
  },
  {
    // This handles both audio and video ad skips when station APS is enabled.
    actionType: UseCaseActions.ActionTypes.SKIP_AD,
    handler: skipAd,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.REPLAY_TRACK,
    handler: replayTrack,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.SCRUB_TRACK,
    handler: scrubTrack,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.SET_SOURCE_REPEAT_MODE,
    handler: setSourceRepeatMode,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.SET_SOURCE_SHUFFLE_MODE,
    handler: setSourceShuffleMode,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.ADD_REPLAY_TRACK_TO_PLAYLIST,
    handler: UseCaseHandlers.addReplayTrackToPlaylist,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.PROMPT_STREAM_VIOLATION,
    handler: UseCaseHandlers.promptStreamViolation,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.START_STATION,
    handler: startStation,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.HANDLE_PREMIUM_ACCESS,
    handler: handlePremiumAccess,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.INITIATE_PREMIUM_ACCESS,
    handler: initiatePremiumAccess,
    concur: 'takeOnly',
  },
  {
    actionType: UseCaseActions.ActionTypes.PLAY_RESUME_SOURCE,
    handler: playResumeSource,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.PLAY_REWARDS_AD,
    handler: playRewardsAd,
    concur: 'takeEvery',
  },
  {
    actionType: UseCaseActions.ActionTypes.CHANGE_INTERACTIVE_RADIO_MODE,
    handler: changeInteractiveRadioMode,
    concur: 'takeLatest',
  },
  // Close the Rewards Coachmark if login fails. We want to try and prevent the anonymous listeners from enabling PA.
  {
    actionType: ApiActions.ApiActions.LOGIN_FAIL,
    handler: closeRewardsCoachmark,
    concur: 'takeEvery',
  },
  {
    actionType: UseCaseActions.ActionTypes.NAVIGATE_TO_COMMUNITY,
    handler: UseCaseHandlers.navigateToCommunity,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.SIGN_UP,
    handler: signUp,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.SIGN_OUT,
    handler: signOut,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.OPEN_SEARCH,
    handler: openSearch,
    concur: 'takeEvery',
  },
  {
    actionType: UseCaseActions.ActionTypes.CLOSE_SEARCH,
    handler: closeSearch,
    concur: 'takeEvery',
  },
  {
    actionType: UseCaseActions.ActionTypes.UPGRADE,
    handler: upgrade,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.OPEN_ERROR_TOAST,
    handler: openErrorToast,
    concur: 'takeLatest',
  },
  {
    actionType: UseCaseActions.ActionTypes.ADD_TRACK_FEEDBACK,
    handler: trackFeedback,
    concur: 'takeEvery',
  },
  {
    actionType: UseCaseActions.ActionTypes.REMOVE_TRACK_FEEDBACK,
    handler: trackFeedback,
    concur: 'takeEvery',
  },
  {
    actionType: UseCaseActions.ActionTypes.GENERATE_DEEP_LINK,
    handler: generateDeepLink,
    concur: 'takeLatest',
  },
];
